'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = formlyValidationMessages;

// @ngInject
function formlyValidationMessages() {

  var validationMessages = {
    addTemplateOptionValueMessage: addTemplateOptionValueMessage,
    addStringMessage: addStringMessage,
    messages: {}
  };

  return validationMessages;

  function addTemplateOptionValueMessage(name, prop, prefix, suffix, alternate) {
    validationMessages.messages[name] = templateOptionValue(prop, prefix, suffix, alternate);
  }

  function addStringMessage(name, string) {
    validationMessages.messages[name] = function () {
      return string;
    };
  }

  function templateOptionValue(prop, prefix, suffix, alternate) {
    return function getValidationMessage(viewValue, modelValue, scope) {
      if (typeof scope.options.templateOptions[prop] !== 'undefined') {
        return prefix + ' ' + scope.options.templateOptions[prop] + ' ' + suffix;
      } else {
        return alternate;
      }
    };
  }
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./providers/formlyValidationMessages.js
 **/